module.exports = __webpack_public_path__ + "img/3.37d90456.png";